export default __webpack_public_path__ + "static/media/sv22_en_star_b1.206c29b1.mp3";